export enum UserPrivileges {
    Normal = 1,
    Workshop = 2,
    Individual = 3
}